module.exports = __webpack_public_path__ + "img/login_back.d804f66a.png";